import SidebarLayout from '../../components/SidebarLayout';
import OutcomesForm from '../../components/sections/MTSS/OutcomesForm';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import React, { useEffect, useContext } from 'react';

export default function Categories() {
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/add-outcome');
  }, []);
  return (
    <AccessWrapper allowedGroups={['mtss_admin']}>
      <div>
        <SidebarLayout
          propComponents={<OutcomesForm />}
          heading={'Add Outcome'}
        />
      </div>
    </AccessWrapper>
  );
}
